export const FETCH_RECOGNIZED_SENDERS_REQUEST = 'FETCH_RECOGNIZED_SENDERS_REQUEST';
export const FETCH_RECOGNIZED_SENDERS_SUCCESS = 'FETCH_RECOGNIZED_SENDERS_SUCCESS';
export const FETCH_RECOGNIZED_SENDERS_FAILURE = 'FETCH_RECOGNIZED_SENDERS_FAILURE';

export const UPDATE_RECOGNIZED_SENDERS_REQUEST = 'UPDATE_RECOGNIZED_SENDERS_REQUEST';
export const UPDATE_RECOGNIZED_SENDERS_SUCCESS = 'UPDATE_RECOGNIZED_SENDERS_SUCCESS';
export const UPDATE_RECOGNIZED_SENDERS_FAILURE = 'UPDATE_RECOGNIZED_SENDERS_FAILURE';

export const UNVERIFIED_ALL_DOMAINS_FOR_SENDER = 'UNVERIFIED_ALL_DOMAINS_FOR_SENDER';
